import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import OnboardingResponse from '../responses/onboarding-response';
import OrderResponse from '../responses/order-response';

@Injectable({
    providedIn: 'root'
})
export class OnboardingRepositoryService {
    constructor(private http: HttpClient) {
    }

    public listByAccountId(accountId: number): Observable<OnboardingResponse> {
        // tslint:disable-next-line:no-console
        return this.http.get<OnboardingResponse>(`${environment.apiUrl}v1/accounts/${accountId}/onboarding`);
    }

    public findByAccountIdAndOrderNo(accountId: number, orderNo: string): Observable<OrderResponse> {
        const orderNoNorm = orderNo.replace('/', '-');

        return this.http.get<OrderResponse>(`${environment.apiUrl}v1/accounts/${accountId}/orders/${orderNoNorm}`);
    }
}
